export default {
  'VIDEO_COMMENT' (state) {
    return state.comment
  },
  'VIDEO_COMMENTS' (state) {
    return state.comments
  }
}
